import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {BsModalService} from "ngx-bootstrap";

@Component({
  selector: 'app-air-ticketing',
  templateUrl: './air-ticketing.component.html',
  styleUrls: ['./air-ticketing.component.scss']
})

export class AirTicketingComponent implements OnInit {
  ticket: any;
  @ViewChild("addModal", {static: true}) addModal;
  @ViewChild("upModal", {static: true}) upModal;
  ticketForm: any;
  items;
  airports: any;
  tickets: any;
  upID: any;
  isup: string;
  modalRef: any;
  dltID: any;
  removeEvt: any;
  page: any;
  totalRec: any;

  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {

    this.ticketForm = this.formBuilder.group({
      price: ["", [Validators.required]],
      destination: ["", [Validators.required]],
      title: ["", [Validators.required]],
      origin: ["", [Validators.required]],
    });

  }

  ngOnInit() {
    this.getAllAirports();
    // this.items=['acd','asda','ads']
    this.ticketGetAll(1)
  }

  declineCancel() {

  }

  confirmCancel() {
    this.delete();
  }

  confirmConfirem() {

  }

  declineConfirem() {
    this.modalRef.hide();
  }

  openModal(errorModal, id: any) {
    this.dltID=id;
    this.modalRef = this.modalService.show(errorModal, {class: 'modal-dialog-centered'});
  }

  createModal() {
    this.isup='add'
    this.ticketForm.reset();
    this.addModal.show();
  }

  createTicket() {
    let req = {
      id:0,
      destination: this.ticketForm.controls.destination.value,
      origin: this.ticketForm.controls.origin.value,
      price: this.ticketForm.controls.price.value,
      title: this.ticketForm.controls.title.value,
    }
    this.userService.createTicket(req).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.notifier.notify('success', res.responseDesc);
          this.upload(res.data);
          this.ticketGetAll(1);
          this.ticketForm.reset();
          this.onRemove(this.removeEvt);
          this.addModal.hide();
        }else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  getAllAirports() {
    this.userService.getAllAirports().subscribe(
      res => {
        if (res.responseCode == 200) {
          this.items = res.data;
        }
      }
    )
  }

  ticketGetAll(pageIndex){
    let req={}
    let size = 10;
    let page = pageIndex - 1;
    this.userService.searchTicket(req,size,page).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.ticket =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        }
      }
    )
  }
  ticketSearch(pageIndex){
    let req={
      destination:this.ticketForm.controls.destination.value,
      origin :this.ticketForm.controls.origin.value,
      title :this.ticketForm.controls.title.value,
    }
    let size = 10;
    let page = pageIndex - 1;
    this.userService.searchTicket(req,size,page).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.ticket =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        }
      }
    )
  }

  delete(){
    this.userService.deleteTicket(this.dltID).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.modalRef.hide();
          this.notifier.notify('success', res.responseDesc);
          this.ticketSearch(this.currentPage);

        }else {
          this.modalRef.hide();
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  update(obj){
    this.addModal.show()
    this.isup ='up'
    this.upID =obj.id;
    this.ticketForm.controls['title'].setValue(obj.title);
    this.ticketForm.controls['price'].setValue(obj.price);
    this.ticketForm.controls['destination'].setValue(obj.destination.id);
    this.ticketForm.controls['origin'].setValue(obj.origin.id);

  }
  updateTicket() {
    let req = {
      id:this.upID,
      destination: this.ticketForm.controls.destination.value,
      origin: this.ticketForm.controls.origin.value,
      price: this.ticketForm.controls.price.value,
      title: this.ticketForm.controls.title.value,
    }
    this.userService.createTicket(req).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.isup='add'
          this.addModal.hide();
          this.notifier.notify('success', res.responseDesc);
          this.ticketGetAll(this.currentPage);
          this.ticketForm.reset();
          this.onRemove(this.removeEvt);
        }else {
          this.isup='add'
          this.addModal.hide();
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  files: File[] = [];
  itForm: any;
  currentPage: any;

  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.removeEvt=event
    this.files.splice(this.files.indexOf(event), 1);
  }

  upload(id) {
    this.userService.uploadTicketImg(this.files[0], id).subscribe(
      data => {
        if (data.responseCode == 200) {
          this.notifier.notify('success', data.responseDesc);
        } else {
          this.notifier.notify('danger', 'Somthing went wrong faild to upload image.');
        }
      });
  }
}
